/**
 * Runtime Configuration Service
 *
 * Fetches multiTenantEnabled from backend at runtime.
 * This allows the same frontend build to work in both modes.
 */

import axios from 'axios';

let cachedConfig = null;
let configPromise = null;

/**
 * Fetch runtime configuration from the backend
 */
export async function fetchRuntimeConfig() {
  if (cachedConfig) return cachedConfig;
  if (configPromise) return configPromise;

  configPromise = (async () => {
    try {
      const response = await axios.get('/content-management-api/public/config', {
        timeout: 5000,
      });
      cachedConfig = response.data?.data || { multiTenantEnabled: false };
    } catch (error) {
      console.warn('Failed to fetch runtime config:', error.message);
      cachedConfig = { multiTenantEnabled: false };
    }
    return cachedConfig;
  })();

  return configPromise;
}

/**
 * Check if multi-tenant mode is enabled
 */
export function isMultiTenantEnabled() {
  return cachedConfig?.multiTenantEnabled === true;
}

export default {
  fetchRuntimeConfig,
  isMultiTenantEnabled,
};
